import { ReactNode, useEffect } from 'react';
import { useAuthStore } from './store.ts';

/**
 * Wraps protected routes. If the user isn't logged in, opens the login modal.
 * Doesn't redirect anywhere — the user stays on the route they tried to visit,
 * which is what the legacy Angular app does too.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const user = useAuthStore(s => s.user);
  const open = useAuthStore(s => s.openLoginModal);
  useEffect(() => {
    if (!user) open();
  }, [user, open]);
  if (!user) return null;
  return <>{children}</>;
}
